import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Accordion, Text, Link} from 'components/UIKit';
import styles from '../../frequently-asked-questions.scss';
import * as locales from './locales';

interface SellerFAQProps {}

export function SellerFAQComponent({i18n}: WithI18nProps & SellerFAQProps) {
  return (
    <Accordion title={i18n.translate('sellers')}>
      <Accordion.Item title={i18n.translate('howToListBusiness')}>
        <Text component="p" resetMargin>
          {i18n.translate('toListBusiness', {
            url1: generateLink(
              i18n.translate('createListingUrl'),
              i18n.translate('installExchangeApp'),
            ),
          })}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('howToSellClosedStore')}>
        <Text component="p" resetMargin>
          {i18n.translate('toSellClosedStore')}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('whyListedAsStarterStore')}>
        <Text component="p" resetMargin>
          {i18n.translate('listedAsStarterStore')}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('canListingBeFeatured')}>
        <Text component="p">{i18n.translate('listingFeaturedOrPromoted')}</Text>
        <Text component="p" resetMargin>
          {i18n.translate('featuredListings', {
            url1: generateLink(
              i18n.translate('listingFeaturedOrPromotedUrl'),
              i18n.translate('theseTips'),
            ),
          })}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('doYouOfferPaymentService')}>
        <Text component="p" resetMargin>
          {i18n.translate('offerPaymentService', {
            url1: generateLink(
              i18n.translate('whyOnlyUseEscrowUrl'),
              i18n.translate('escrowDotCom'),
            ),
            url2: generateLink(i18n.translate('howItWorksUrl'), i18n.translate('thisGuide')),
          })}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('howValuationCalculated')}>
        <Text component="p">{i18n.translate('valuationCalculated')}</Text>
        <Text component="p" resetMargin>
          {i18n.translate('onlyWhitelisted', {
            url1: generateLink(i18n.translate('whitelistSalesUrl'), i18n.translate('seeHere')),
          })}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('howToBuyerQuick')}>
        <Text component="p">{i18n.translate('startBy')}</Text>
        <ul className={styles.list}>
          <Text component="li">{i18n.translate('typeOfProducts')}</Text>
          <Text component="li">{i18n.translate('whatToConsider')}</Text>
          <Text component="li">{i18n.translate('linksToSocialMedia')}</Text>
        </ul>
        <Text component="p" resetMargin>
          {i18n.translate('learnMoreTips', {
            url1: generateLink(
              i18n.translate('tipsToFindingBuyerUrl'),
              i18n.translate('improvingYourListing'),
            ),
          })}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('howToTransferStore')}>
        <Text component="p">
          {i18n.translate('toTransferStore', {
            url1: generateLink(i18n.translate('howItWorksUrl'), i18n.translate('theseSteps')),
          })}
        </Text>
        <Text component="p" resetMargin>
          {i18n.translate('onlyWay')}
        </Text>
      </Accordion.Item>
    </Accordion>
  );
}

const generateLink = (url, text) => {
  return <Link rel="noopener noreferrer" forcePink url={url} text={text} newTab />;
};

export const SellerFAQ = withI18n({
  id: 'SellerFAQ',
  fallback: locales.en,
})(SellerFAQComponent);
